export default "__VITE_ASSET___vUOyxz$__"